import isConsumer from "owa-session-store/lib/utils/isConsumer";
import { IsChildConsumerUser, IsShadowMailboxUser } from "owa-mail-ads-shared";
import type { MailboxInfo } from "owa-client-types";
import { isPremiumConsumer } from "owa-session-store";

export function shouldShowUpsellOption(mailboxInfo: MailboxInfo, isMSQ: boolean): boolean {
    const isValidConsumer: boolean = isConsumer(undefined, mailboxInfo) &&
        !IsChildConsumerUser(mailboxInfo) &&
        !IsShadowMailboxUser(mailboxInfo);
    return isMSQ ? isValidConsumer : isValidConsumer && !isPremiumConsumer(mailboxInfo);
}
